var indentation_default = {
  "indentZero": "-Gy9d",
  "indentOne": "RrYfs",
  "indentTwo": "_7mE8U",
  "indentThree": "TX81W",
  "indentFour": "F0tiY",
  "indentFive": "QUa57",
  "indentSix": "_6GfiE"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
